import { IAttrValue } from "@multiweb/types/contracts";
import { StringUtils } from "Global/Base/Utils/StringUtils";
import { AttrValueReader } from "../../../../OW.Remoting/Remoting/AttrValueReader";
import { registerCustomElement } from "../../../UI.ElementarControls/Utils/CustomElementUtils";
import { Column } from "./Column";

/** Typ sloupce pro zobrazení ořezaného HTML textu. */
export class HTMLTextColumn extends Column {
    public override async formatValue(data: IAttrValue | IAttrValue[]): Promise<string> {
        if (data instanceof Array)
            return "";

        const val = AttrValueReader.read(data);
        if (val) {
            return StringUtils.stripHTMLFromText(val);
        } else {
            return "";
        }
    }
}

registerCustomElement("tsc-htmltextcolumn", HTMLTextColumn);
